import React, { createContext, useState, useContext } from 'react';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [activeLanguage, setActiveLanguage] = useState('fr');

  const updateLanguage = (language) => {
    setActiveLanguage(language);
  };

  return (
    <LanguageContext.Provider value={{ activeLanguage, updateLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);

